<template>
  <div class="question-options-editor">
    <label class="form-label">Response Options</label>
    <p v-if="localOptions.length === 0" style="color: #aaa; margin-bottom: 8px">
      No options yet. Add at least one selectable response.
    </p>
    <div
      v-for="(opt, index) in localOptions"
      :key="index"
      class="option-row mb-2"
    >
      <span class="option-index">{{ index + 1 }}.</span>
      <el-input
        :value="opt"
        @input="updateOption(index, $event)"
        placeholder="Option text"
        size="small"
        class="option-input"
      />
      <el-button-group class="ml-2">
        <el-button
          size="mini"
          :disabled="index === 0"
          title="Move up"
          @click="move(index, -1)"
        >
          <i class="fa-solid fa-arrow-up"></i>
        </el-button>
        <el-button
          size="mini"
          :disabled="index === localOptions.length - 1"
          title="Move down"
          @click="move(index, 1)"
        >
          <i class="fa-solid fa-arrow-down"></i>
        </el-button>
        <el-button
          size="mini"
          type="danger"
          title="Remove option"
          @click="remove(index)"
        >
          <i class="fa-solid fa-trash"></i>
        </el-button>
      </el-button-group>
    </div>
    <el-button size="small" type="primary" plain @click="add">
      <i class="fa-solid fa-circle-plus mr-1"></i> Add Option
    </el-button>
  </div>
</template>

<script>
export default {
  name: "ShiftQuestionOptionsEditor",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    localOptions() {
      return Array.isArray(this.value) ? this.value : [];
    },
  },
  methods: {
    emitChange(next) {
      this.$emit("input", next);
    },
    updateOption(index, val) {
      const next = [...this.localOptions];
      next[index] = val;
      this.emitChange(next);
    },
    add() {
      this.emitChange([...this.localOptions, ""]);
    },
    remove(index) {
      const next = [...this.localOptions];
      next.splice(index, 1);
      this.emitChange(next);
    },
    move(index, delta) {
      const target = index + delta;
      if (target < 0 || target >= this.localOptions.length) return;
      const next = [...this.localOptions];
      [next[index], next[target]] = [next[target], next[index]];
      this.emitChange(next);
    },
  },
};
</script>

<style scoped>
.question-options-editor {
  margin-top: 8px;
}
.option-row {
  display: flex;
  align-items: center;
}
.option-index {
  color: #aaa;
  width: 24px;
  flex-shrink: 0;
}
.option-input {
  flex: 1;
}
</style>
